import styled from '@emotion/styled'

export const StyleSearchWrapper = styled.div`
  display: flex;
`

export const StyleInputWrapper = styled.div`
  position: relative;
  display: flex;
  background: ${(props: any) => props.theme.colors.white};
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  padding: 0px 10px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  height: 45px;
  width: 100%;
`
export const StyleInput = styled.input`
  height: 43px;
  padding: 0px;
  margin: 0px;
  outline: none;
  font-size: 14px;
  border: 0px;
  text-indent: 10px;
  flex: 1;

  &::placeholder {
    font-size: 14px;
    color: ${(props: any) => props.theme.colors.placeholder};
    font-weight: 400;
  }
`
export const StyleIconWrapper = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
`

export const StyleButton = styled.button`
  background: ${(props: any) => props.theme.colors.primary};
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.white};
  border: 0px;
  padding: 0px 40px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
`
